export { default } from './DashFooter';
